import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import api, { formatTL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="account-page" className="container-max px-4 md:px-8 section-pad">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mb-2">Hesabım</h1>
      <p className="text-slate-600 mb-8">Hoş geldin, <span className="font-semibold">{user?.name}</span></p>

      <div className="grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <div className="bg-white rounded-2xl p-4 border border-slate-100 space-y-1">
            <Link to="/hesabim" className="block px-3 py-2 rounded-lg font-semibold bg-[#0077B6]/10 text-[#0077B6]">Siparişlerim</Link>
            <Link to="/hesabim/favoriler" className="block px-3 py-2 rounded-lg font-semibold hover:bg-slate-50">Favorilerim</Link>
          </div>
        </aside>
        <main className="lg:col-span-9">
          {orders.length === 0 ? (
            <div className="bg-white rounded-2xl p-10 border border-slate-100 text-center">
              <p className="text-slate-600">Henüz sipariş vermediniz.</p>
              <Link to="/urunler" className="btn-primary mt-4 inline-flex">Alışverişe Başla</Link>
            </div>
          ) : (
            <div className="space-y-3">
              {orders.map((o) => (
                <div key={o.id} className="bg-white rounded-2xl border border-slate-100 p-5">
                  <div className="flex justify-between flex-wrap gap-2">
                    <div>
                      <div className="font-display font-extrabold text-lg">#{o.order_no}</div>
                      <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString("tr-TR")}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-display text-xl font-extrabold text-[#0077B6]">{formatTL(o.total)}</div>
                      <span className="text-xs font-semibold uppercase tracking-wider bg-[#F4F7F9] px-2 py-0.5 rounded-full">{o.status}</span>
                    </div>
                  </div>
                  <div className="text-sm text-slate-600 mt-2">{o.items.map((it) => `${it.name} × ${it.quantity}`).join(", ")}</div>
                  {o.delivery?.otogar && (
                    <div className="text-xs text-[#0077B6] mt-1 font-semibold">🚌 Teslim alınacak otogar: {o.delivery.otogar}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export function Favorites() {
  const [favs, setFavs] = useState([]);
  useEffect(() => { api.get("/me/favorites").then((r) => setFavs(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="favorites-page" className="container-max px-4 md:px-8 section-pad">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mb-8">Favorilerim</h1>
      {favs.length === 0 ? (
        <p className="text-slate-600">Henüz favoriniz yok.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {favs.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
